// extracted by mini-css-extract-plugin
export var explainable = "_g4-a";
export var printerCard = "_g4-1";
export var printerCardConfigured = "_g4-2";
export var printerCardError = "_g4-3";
export var printerCardsContainer = "_g4-0";
export var printerIcon = "_g4-8";
export var printerIconConfigured = "_g4-5";
export var printerIconContainer = "_g4-4";
export var printerIconError = "_g4-6";
export var printerIconUnconfigured = "_g4-7";
export var workstationsTableCard = "_g4-9";